import React from "react";
import { Table, Typography } from "antd";
import Nebulization from "./Nebulization";

const { Paragraph, Text } = Typography;

const Medication = ({ details }) => {
  const medications = details?.data?.medications;

  const columns = [
    {
      title: "Form",
      dataIndex: "form",
      key: "form",
      render: (value, record) =>
        value
          ? value === "Others" && record?.other_form
            ? `${value} - ${record.other_form}`
            : value
          : "-",
    },
    { title: "Medication", dataIndex: "name", key: "name" },
    {
      title: "Dose",
      dataIndex: "dose",
      key: "dose",
      render: (value, record) =>
        value || value === 0 ? `${value}${record?.unit ? ` ${record.unit}` : ""}` : "-",
    },
    {
      title: "Frequency",
      dataIndex: "frequency",
      key: "frequency",
      render: (value) => value?.replaceAll("_", " "),
    },
    { title: "Route", dataIndex: "route", key: "route" },
    {
      title: "Comments",
      dataIndex: "comments",
      key: "comments",
      render: (value) =>
        value ? (
          <Paragraph
            ellipsis={{
              rows: 2,
              expandable: true,
              symbol: "more",
            }}
            style={{
              width: "100%",
              maxWidth: "100%",
              marginBottom: 0,
              whiteSpace: "normal",
              wordBreak: "break-word",
            }}
          >
            {value}
          </Paragraph>
        ) : (
          "-"
        ),
    },
  ];
  return (
    <>
      <Table
        dataSource={medications}
        pagination={false}
        columns={columns}
        scroll={{ x: "600px" }}
      />
      {/* Nebulisation is part of the medication picture, so it reads as a
          sub-section here rather than as its own collapsible panel. */}
      <Text className="forms-ip-subsection-title">Nebulization</Text>
      <Nebulization details={details} />
    </>
  );
};

export default Medication;
